__turbopack_context__.v({
  "alternate-ui": "B58-kq_alternate-ui",
  "alternate-ui-gradient": "B58-kq_alternate-ui-gradient",
  "alternateUI": "B58-kq_alternateUI",
  "content": "B58-kq_content",
  "corporate-element": "B58-kq_corporate-element",
  "corporate-head": "B58-kq_corporate-head",
  "corporate-metrics": "B58-kq_corporate-metrics",
  "corporate-subtitle": "B58-kq_corporate-subtitle",
  "id-text": "B58-kq_id-text",
  "logo": "B58-kq_logo",
  "media-image": "B58-kq_media-image",
  "noise-bg": "B58-kq_noise-bg",
  "normalUI": "B58-kq_normalUI",
  "org-collab-tag": "B58-kq_org-collab-tag",
  "root": "B58-kq_root",
  "scaleAnim": "B58-kq_scaleAnim",
  "separator": "B58-kq_separator",
  "zomato": "B58-kq_zomato",
});
